export default __webpack_public_path__ + "static/media/gcp.ff97432c.png";